"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfCreatePriceDropAlertDto = instanceOfCreatePriceDropAlertDto;
exports.CreatePriceDropAlertDtoFromJSON = CreatePriceDropAlertDtoFromJSON;
exports.CreatePriceDropAlertDtoFromJSONTyped = CreatePriceDropAlertDtoFromJSONTyped;
exports.CreatePriceDropAlertDtoToJSON = CreatePriceDropAlertDtoToJSON;
exports.CreatePriceDropAlertDtoToJSONTyped = CreatePriceDropAlertDtoToJSONTyped;
/**
 * Check if a given object implements the CreatePriceDropAlertDto interface.
 */
function instanceOfCreatePriceDropAlertDto(value) {
    if (!('alertPrice' in value) || value['alertPrice'] === undefined)
        return false;
    return true;
}
function CreatePriceDropAlertDtoFromJSON(json) {
    return CreatePriceDropAlertDtoFromJSONTyped(json, false);
}
function CreatePriceDropAlertDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'alertPrice': json['alertPrice'],
    };
}
function CreatePriceDropAlertDtoToJSON(json) {
    return CreatePriceDropAlertDtoToJSONTyped(json, false);
}
function CreatePriceDropAlertDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'alertPrice': value['alertPrice'],
    };
}
